import { API_BASE_URL } from "../config/apiBase";
import { adminAuthHeaders } from "../utils/adminApi";

export const siteCmsUrls = {
  socialLinks: `${API_BASE_URL}/site/social-links`,
  about: `${API_BASE_URL}/site/about`,
  homeHero: `${API_BASE_URL}/site/home-hero`,
  blogs: `${API_BASE_URL}/site/blogs`,
  projects: `${API_BASE_URL}/site/projects`,
};

export const authJsonHeaders = () => adminAuthHeaders();

export const authOnlyHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
